import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Menu, MenuItem, Fade, ListItemText, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormMode, USysObjects } from '../utils/extensions/constantEx'
import VisibilityIcon from '@mui/icons-material/Visibility';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import { HomeContext } from '../utils/contexts/homeContext';

const NurseMenuPopup = (props) => {
    const { homeState } = useContext(HomeContext);

    const { nurseRow, handleDeleteClick } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleNewServiceClick = () => {
        handleMoreClose();
        navigate("/service-form", {
            replace: false,
            state: {
                from: 'nurse-search',
                formMode: FormMode.NewMode,
                selectedNurseId: nurseRow.id
            }
        });
    }

    const handleNewServiceBookingClick = () => {
        handleMoreClose();
        navigate("/nurse-service-booking-form", {
            replace: false,
            state: {
                from: 'nurse-search',
                formMode: FormMode.NewMode,
                selectedNurseId: nurseRow.id,
                selectedNurseName: nurseRow.nurse_name
            }
        });
    }

    const handleViewServiceClick = () => {
        handleMoreClose();
        navigate("/service-form", { replace: false });
    }

    const handleNewSalaryPaymentClick = () => {
        handleMoreClose();
        navigate("/nurses-salary-form", { replace: false });
    }

    const handleViewSalaryPaymentClick = () => {
        handleMoreClose();
        navigate("/nurses-salary-payments", { replace: false });
    }

    const handleEditClick = () => {
        handleMoreClose();
        navigate("/nurse-form", {
            replace: false,
            state: {
                formMode: FormMode.ViewMode,
                from: 'nurse-search',
                selectedId: nurseRow.id
            }
        });
    }

    const handleMenuDeleteClick = () => {
        handleMoreClose();
        handleDeleteClick(nurseRow.id);
    }

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMoreClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton onClick={handleMoreClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMoreClose}
                slotProps={{
                    transition: Fade
                }}
            >
                {
                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_add_new) &&
                    !nurseRow.is_service_found &&
                    <MenuItem onClick={handleNewServiceClick} disableRipple>
                        <ListItemIcon>
                            <HomeRepairServiceIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>New Service</ListItemText>
                    </MenuItem>
                }
                {
                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new) &&
                    <MenuItem onClick={handleNewServiceBookingClick} disableRipple>
                        <ListItemIcon>
                            <BookmarkAddIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>New Service Booking</ListItemText>
                    </MenuItem>
                }
                {/* <MenuItem onClick={handleViewServiceClick} disableRipple>
                    View Service
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem onClick={handleNewSalaryPaymentClick} disableRipple>
                    New Salary Payment
                </MenuItem>
                <MenuItem onClick={handleViewSalaryPaymentClick} disableRipple>
                    View Salary Payments
                </MenuItem> */}
                {
                    (homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_add_new)
                        || homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new)) &&
                    <Divider sx={{ my: 0.5 }} />
                }
                <MenuItem onClick={handleEditClick} disableRipple>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View</ListItemText>
                </MenuItem>
                {
                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_delete) &&
                    <MenuItem onClick={handleMenuDeleteClick} disableRipple>
                        <ListItemIcon>
                            <RemoveCircleOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                    </MenuItem>
                }
            </Menu>

        </Box>

    );
}
export default NurseMenuPopup;